<div class="inline-number-wrapper">
  @if (!isEditing) {
    <span class="left">
      @if (!value) {
        <a (click)="startEdit()" class="add"> Select an option </a>
      }
      @if (multiple && coerceArray(value)?.length === 0) {
        <a (click)="startEdit()" class="add"> Select option(s) </a>
      }
      @if (!multiple) {
        <span>
          {{ value }}
        </span>
      }
      @if (multiple) {
        <span>
          {{ coerceArray(value)?.join(', ') }}
        </span>
      }
      @if (value) {
        <button class="edit-button" mat-icon-button (click)="startEdit()">
          <mat-icon class="edit-icon">edit</mat-icon>
        </button>
      }
    </span>
  }
  <div
    class="editing"
    [ngClass]="{
      hidden: !isEditing
    }"
    >
    <div appearance="outline">
      <ng-select
        appearance="outline"
        [items]="options"
        bindLabel="label"
        bindValue="value"
        placeholder="Select a value"
        [(ngModel)]="pendingValue"
      ></ng-select>
    </div>
    <div class="button-container">
      <button mat-button (click)="cancelEdit()">CANCEL</button>
      <button mat-button class="save" (click)="confirmEdit()">SAVE</button>
    </div>
  </div>
</div>
